<template>
  <div class="pb-2">
    <label v-if="label" :for="id" class="label-lg block py-1 px-2">
      <span> {{ label }} </span>
      <span v-if="required" class="text-error"> * </span>
    </label>
    <textarea
      :id="id"
      :name="id"
      ref="input"
      v-bind="$attrs"
      :class="{
        'body-lg w-full block rounded-lg p-3 pl-4 border border-outline focus:outline-none focus:border-primary focus:ring focus:ring-primary-container active:outline-none': true,
        'border-error': error,
      }"
      :value="value"
      :rows="rows"
      :maxlength="maxlength"
      @input="$emit('input', $event.target.value)"
    />
    <div class="flex mt-1">
      <div v-if="error || hint" class="text-caption px-2 text-neutral40 opacity-80">
        <p v-if="error" class="text-error">{{ error.charAt(0).toUpperCase() + error.slice(1) }}</p>
        <p v-else-if="hint">{{ hint }}</p>
      </div>
      <small
        v-if="maxlength"
        :class="[
          'block text-chips text-right text-[80%] shrink-0 grow',
          length === maxlength ? 'text-error font-bold' : 'text-neutral40',
        ]"
      >
        {{ length }} / {{ maxlength }}
      </small>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    id: {
      type: String,
      default() {
        return `textarea-input-${this._uid}`
      },
    },
    maxlength: {
      type: Number,
    },
    rows: {
      type: Number,
      default: 2,
    },
    value: { type: String, default: '' },
    label: String,
    error: String,
    required: {
      type: Boolean,
      default: false,
    },
    hint: String,
  },
  methods: {
    focus() {
      this.$refs.input.focus()
    },
    select() {
      this.$refs.input.select()
    },
  },
  computed: {
    length() {
      return this.value ? this.value.length : 0
    },
  },
}
</script>
